module.exports = __webpack_public_path__ + "static/img/hdzqt.df3c02a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hdzqt.png
// module id = AnDg
// module chunks = 1